module.exports = __webpack_public_path__ + "assets/media/app-store-footer.ec4115d7.svg";